import { Grid, TextField, Button } from "@material-ui/core";
import { useStyles } from "../style";

export default function UrlConsole(props) {
    const classes = useStyles();
    const { setActiveBtn } = props;

    const handleCancel = () => {
        setActiveBtn('');
    }

    const handleSave = () => {
        setActiveBtn('');
    }
    return (
        <>
            <Grid item xs={6}>
                <TextField fullWidth
                    name="name"
                    label="Name"
                    variant="outlined"
                    classes={{ root: classes.textField }}
                    InputProps={{
                        classes: {
                            input: classes.inputField,
                            root: classes.base,
                            focused: classes.focused,
                            notchedOutline: classes.notchedOutline
                        },
                    }}
                    InputLabelProps={{
                        shrink: true,
                        style: { color: '#2a2c2e' },
                    }}
                />
            </Grid>
            <Grid item xs={6} className={classes.gridOutline}>
                <TextField fullWidth
                    name="url"
                    label="Url"
                    variant="outlined"
                    classes={{ root: classes.textField }}
                    InputProps={{
                        classes: {
                            input: classes.inputField,
                            root: classes.base,
                            focused: classes.focused,
                            notchedOutline: classes.notchedOutline
                        },
                    }}
                    InputLabelProps={{
                        shrink: true,
                        style: { color: '#2a2c2e' },
                    }}
                />
            </Grid>
            <Grid item xs={6} className={classes.gridOutline}>
                <TextField fullWidth
                    name="order"
                    type='number'
                    label="Order"
                    variant="outlined"
                    classes={{ root: classes.textField }}
                    InputProps={{
                        classes: {
                            input: classes.inputField,
                            root: classes.base,
                            focused: classes.focused,
                            notchedOutline: classes.notchedOutline
                        },
                    }}
                    InputLabelProps={{
                        shrink: true,
                        style: { color: '#2a2c2e' },
                    }}
                />
            </Grid>
            <Grid item xs={6} className={classes.gridOutline}>
                <Button
                    className={classes.cancelBtn}
                    onClick={handleCancel}
                >
                    Cancel
                </Button>
                <Button
                    className={classes.saveBtn}
                    onClick={handleSave}
                >
                    Save
                </Button>
            </Grid>
        </>
    )
}